import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const painPoints = ['De la mujer que llegás a la noche agotada y abrís la heladera sin saber qué cocinar.', 'Que compraste ingredientes con buena intención el lunes y el viernes los tiraste porque no los usaste.', 'Que buscaste en Google "qué comer con hipotiroidismo" y cerraste la pestaña más confundida que cuando la abriste.', 'Que tu médico te dijo "cuidá la alimentación" y no te explicó nada más.', 'Que encontraste información en Instagram, en grupos de Facebook, en videos de TikTok, todos diciendo cosas distintas y algunas contradictorias, y ya no sabés en qué creer.', 'Que querés comer bien pero también querés comer rico, no insípido, no de dieta, no cocinando dos versiones distintas para vos y para tu familia.', 'Que a veces te sentís culpable por pedir delivery, por comer algo "que no debías", por no haber tenido energía para cocinar lo que tenías planeado.', 'Que llegás al final del día sin fuerzas y lo último que querés es ponerte a pensar en macros, en ingredientes difíciles de conseguir o en recetas de 45 pasos.'];
const knowingGaps = ['Podés saber que el gluten puede interferir con tu tiroides y no tener ni idea de cómo reemplazar la pasta, el pan y las galletitas sin que cada comida se sienta como un castigo.', 'Podés saber que el selenio y el zinc son importantes y no saber qué alimentos los tienen, cuáles conseguís en el supermercado del barrio y cómo incorporarlos sin complicarte.', 'Podés saber que tenés que evitar la soja y no entender por qué aparece en etiquetas que nada tienen que ver con la soja, disfrazada con nombres que no reconocés.', 'Podés saber que cocinar bien para tu tiroides es posible y llegar a las 20:00 tan agotada que lo único que podés hacer es abrir el delivery más cercano sin saber si lo que pedís te va a hacer bien o mal.', 'Podés saber que la inflamación impacta en cómo te sentís y no tener ninguna herramienta concreta para reducirla en tu cocina de todos los días, con los ingredientes que conseguís en cualquier verdulería argentina.'];
export function PainSection() {
  return <section className="bg-white py-20 sm:py-28" aria-labelledby="pain-title" data-id="element-76">
      <div className="mx-auto max-w-3xl px-5" data-id="element-77">
        <h2 id="pain-title" className="font-serif text-3xl font-semibold text-ink sm:text-4xl" data-id="element-78">
          Hablemos de vos.
        </h2>

        <div className="mt-8 space-y-4" data-id="element-79">
          {painPoints.map((p, i) => <motion.p key={i} initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.03
        }} className="border-l-2 border-sage/40 pl-4 text-[17px] leading-relaxed text-ink/75" data-id="element-80">
              {p}
            </motion.p>)}
        </div>

        <p className="mt-10 font-serif text-2xl font-semibold text-sage-deep" data-id="element-81">
          Esa sos vos.
        </p>
        <p className="mt-4 text-[17px] leading-relaxed text-ink/80" data-id="element-82">
          Y el problema no es que no tengas voluntad.
        </p>
        <p className="mt-2 text-[17px] font-semibold leading-relaxed text-ink" data-id="element-83">
          El problema es que nadie te dio un sistema que funcione en tu vida
          real.
        </p>

        {/* Knowing vs doing */}
        <div className="mt-16 rounded-3xl bg-cream p-6 sm:p-10" data-id="element-84">
          <h3 className="font-serif text-2xl font-semibold leading-snug text-ink sm:text-3xl" data-id="element-85">
            El problema no es que no sepas que la alimentación importa.
          </h3>
          <p className="mt-4 text-[17px] leading-relaxed text-ink/80" data-id="element-86">
            El problema es que saber que importa y tener el sistema exacto para
            aplicarlo todos los días son dos cosas completamente distintas.
          </p>

          <ul className="mt-6 space-y-4" data-id="element-87">
            {knowingGaps.map((g, i) => <li key={i} className="flex gap-3 text-[16px] leading-relaxed text-ink/75" data-id="element-88">
                <span className="mt-1 select-none font-bold text-coral" aria-hidden="true" data-id="element-89">
                  →
                </span>
                <span data-id="element-90">{g}</span>
              </li>)}
          </ul>

          <p className="mt-8 font-serif text-xl font-semibold uppercase leading-snug tracking-wide text-sage-deep sm:text-2xl" data-id="element-91">
            El cuerpo con hipotiroidismo necesita información concreta. No más
            teoría.
          </p>
        </div>

        <div className="mt-12 text-center" data-id="element-92">
          <CTAButton variant="sage" size="lg" data-id="element-93">
            Mostrame el sistema completo
          </CTAButton>
        </div>
      </div>
    </section>;
}